<template>
  <div class="row">
    <div class="col d-flex">
      <textarea class="form-control custom-new-note" rows="3" v-model="note" @input="changed"></textarea>
      <button class="btn btn-primary btn-sm custom-save-note" :class="{ 'btn-danger': isSave }" @click="saveNote" :disabled="!isSave">Save</button>
    </div>
  </div>
  <div class="row custom-wrapper">
    <div class="col">
      <ul class="custom-list">
        <li v-for="note in requestNotes" :key="note.id">
          <div class="row custom-note-header">
            <div class="col-4">
              <span>{{ formatDate(note.createdDate) }}</span>
            </div>
            <div class="col">
              <span>{{ note.createdBy }}</span>
            </div>
            <div class="col-1 text-right">
              <a v-if="isAuthor(note.createdBy)" href="#" class="custom-trash" @click="deleteNote(note.calibrateRequestNote)">
                <i class="fa-solid fa-trash"></i>
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col custom-note">
              <span>{{ note.note }}</span>
            </div>
          </div>
          <div class="row custom-note-footer">
            <div class="col">
              <span>read by: {{ note.readBy }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirmTitle="confirmTitle"
    :confirmAction="confirmAction"
    :confirmQuestion="confirmQuestion"
    @closing="closeModal"
    @proceed="performDelete"
  />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { opportunityStore } from '@/stores/opportunity'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import moment from 'moment'
export default {
  name: 'RequestNotes',
  components: {
    ConfirmDelete
  },
  data() {
    return {
      confirmTitle: 'Remove Note?',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove this Note?',
      actionDelete: null,
      isSave: false,
      note: '',
      currentId: null
    }
  },
  mounted() {
    this.isSave = false
    this.actionDelete = null
    this.currentId = null
    // this.emitter.on('process-opportunity', (data) => {
    //   if (data) {
    //     console.log('In Request Notes', {
    //       opportunity: this.opportunity,
    //       data: data
    //     })
    //     if (this.opportunity) {
    //       if (
    //         data.source === this.opportunity.source &&
    //         (parseInt(data.id) === parseInt(this.opportunity.adasInspection) || parseInt(data.event) === parseInt(this.opportunity.opportunity))
    //       ) {
    //         this.getRequestNotes({
    //           calibrateRequest: this.opportunity.calibrateRequest,
    //           opportunity: this.opportunity.opportunity,
    //           readBy: `${this.profile.firstName} ${this.profile.lastName}`
    //         })
    //       }
    //     }
    //   }
    // })
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(opportunityStore, ['loading', 'opportunity', 'notes']),
    requestNotes() {
      let _notes = []
      if (this.notes) {
        _notes = this.notes.filter((note) => !note.isRemoved && note.noteType === 2)
      }
      return _notes
    }
  },
  methods: {
    ...mapActions(opportunityStore, ['getRequestNotes', 'deleteRequestNote', 'saveRequestNote']),
    changed() {
      this.isSave = true
    },
    closeModal() {
      this.actionDelete = null
      this.currentId = null
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY hh:mm A')
    },
    isAuthor(author) {
      return author === `${this.profile.firstName} ${this.profile.lastName}`
    },
    deleteNote(id) {
      console.log('Delete Note', id)
      this.currentId = id
      this.actionDelete = true
    },
    async performDelete() {
      await this.deleteRequestNote(this.currentId)
      await this.getRequestNotes({
        calibrateRequest: this.opportunity.calibrateRequest,
        opportunity: this.opportunity.opportunity,
        readBy: `${this.profile.firstName} ${this.profile.lastName}`
      })
      this.closeModal()
    },
    async saveNote() {
      if (this.note) {
        let data = {
          calibrateRequest: this.opportunity.calibrateRequest,
          opportunity: this.opportunity.opportunity,
          note: this.note.trim(),
          noteType: 2,
          createdBy: `${this.profile.firstName} ${this.profile.lastName}`,
          readBy: `${this.profile.firstName} ${this.profile.lastName}`
        }
        await this.saveRequestNote(data)
        this.note = ''
        await this.getRequestNotes({
          calibrateRequest: this.opportunity.calibrateRequest,
          opportunity: this.opportunity.opportunity,
          readBy: `${this.profile.firstName} ${this.profile.lastName}`
        })
        this.isSave = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  margin-top: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
}
.custom-title {
  font-size: 1.2em;
  font-weight: 500;
}
.custom-list {
  list-style-type: none;
  padding: 0;
  li {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
    margin-bottom: 5px;
  }
}
.custom-note-header {
  font-size: 0.8em;
  font-style: italic;
  padding: 2px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8eaf1;
  i {
    border: 1px solid #e8eaf1;
    color: rgb(88, 0, 0);
    border-radius: 5px;
  }
}
.custom-note {
  padding: 2px;
  margin-left: 15px;
  margin-right: 15px;
}
.custom-note-footer {
  font-size: 0.8em;
  font-style: italic;
  padding: 2px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 10px;
  border-top: 1px solid #e8eaf1;
  text-align: right;
}
.custom-trash {
  position: relative;
  top: 0;
  right: 0;
  font-size: 1.2em;
  color: rgb(88, 0, 0) !important;
  text-align: right;
}
.custom-new-note {
  width: 100%;
  height: 48px;
}
.custom-save-note {
  margin-left: 5px;
  height: 32px;
}
</style>
